import React, { useCallback, useEffect, useRef, useState } from "react";

const RAW_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
const SITE_KEY = RAW_KEY.startsWith("0x4") ? RAW_KEY : "";
const SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let scriptPromise;
const loadTurnstile = () => {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = SRC;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("turnstile"));
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
};

const TurnstileBox = ({ action, onToken, widgetRef }) => {
  const host = useRef(null);
  useEffect(() => {
    let cancelled = false;
    loadTurnstile().then(() => {
      if (cancelled || !host.current) return;
      widgetRef.current = window.turnstile.render(host.current, {
        sitekey: SITE_KEY, action, theme: "dark", size: "flexible",
        callback: onToken, "expired-callback": () => onToken(""), "error-callback": () => onToken(""),
      });
    }).catch(() => onToken(""));
    return () => {
      cancelled = true;
      if (widgetRef.current && window.turnstile) window.turnstile.remove(widgetRef.current);
    };
  }, [action, onToken, widgetRef]);
  return <div ref={host} className="w-full basis-full min-h-[65px] overflow-hidden rounded-lg" data-testid={`turnstile-${action}`} />;
};

/* Bot protection for public forms: hidden honeypot + fill-time check + Cloudflare Turnstile (when configured) */
export const useBotGuard = (action) => {
  const startedAt = useRef(Date.now());
  const widgetRef = useRef(null);
  const [token, setToken] = useState("");
  const [trap, setTrap] = useState("");
  const onToken = useCallback((t) => setToken(t || ""), []);
  const fields = () => ({ turnstile_token: token || null, website: trap, form_started_at: startedAt.current });
  const reset = () => {
    startedAt.current = Date.now();
    setToken("");
    if (widgetRef.current && window.turnstile) window.turnstile.reset(widgetRef.current);
  };
  const guard = (
    <>
      <div className="absolute -left-[10000px] w-px h-px overflow-hidden" aria-hidden="true">
        <label>Website<input tabIndex={-1} autoComplete="off" value={trap} onChange={(e) => setTrap(e.target.value)} /></label>
      </div>
      {SITE_KEY && <TurnstileBox action={action} onToken={onToken} widgetRef={widgetRef} />}
    </>
  );
  return { fields, guard, reset, ready: !SITE_KEY || !!token };
};
